import * as Popper from '@popperjs/core'; // Importa o do npm
window.Popper = Popper;

import * as bootstrap from 'bootstrap'; // Importa o Bootstrap
window.bootstrap = bootstrap; // Expõe globalmente

import axios from 'axios';
window.axios = axios;

import Swal from 'sweetalert2';
window.Swal = Swal;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Configuração do Laravel Echo com Reverb (servidor de socket em socket.nilobezerra.adv.br).
// As variáveis VITE_REVERB_* são lidas no BUILD (npm run build): trocar no App Platform exige novo deploy.
// Canais do chat são PRIVADOS: o Echo pede a assinatura em /broadcasting/auth (sessão + CSRF).
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
window.Pusher = Pusher;

const reverbKey = import.meta.env.VITE_REVERB_APP_KEY;

if (reverbKey) {
    const csrf = document.querySelector('meta[name="csrf-token"]');

    window.Echo = new Echo({
        broadcaster: 'reverb',
        key: reverbKey,
        wsHost: import.meta.env.VITE_REVERB_HOST || '127.0.0.1',
        wsPort: import.meta.env.VITE_REVERB_PORT || 8080,
        wssPort: import.meta.env.VITE_REVERB_PORT || 8080,
        forceTLS: (import.meta.env.VITE_REVERB_SCHEME || 'http') === 'https',
        enabledTransports: ['ws', 'wss'],
        disableStats: true,
        authEndpoint: '/broadcasting/auth',
        auth: {
            headers: {
                'X-CSRF-TOKEN': csrf ? csrf.getAttribute('content') : '',
                Accept: 'application/json',
            },
        },
    });
} else {
    // Sem a key não há como conectar (e não existe mais key "de reserva" escrita no código).
    console.warn('VITE_REVERB_APP_KEY ausente no build: o chat funciona só pela sincronização periódica.');
}
